import { ArrowRight } from 'lucide-react';

export function Hero() {
  const scrollToContact = () => {
    document.getElementById('contact')?.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <section className="relative bg-gradient-to-br from-neutral-50 to-neutral-100 pt-32 pb-20 px-6">
      <div className="max-w-6xl mx-auto text-center">
        <h1 className="text-5xl md:text-6xl font-light text-neutral-900 mb-6 tracking-tight">
          Quality Furniture & Interior Fittings for{' '}
          <span className="font-normal text-neutral-700">Professional Spaces</span>
        </h1>
        <p className="text-xl md:text-2xl text-neutral-600 mb-10 max-w-3xl mx-auto font-light">
          Wholesale supplier of furniture, carpets and lighting equipment across the UK
        </p>
        <button
          onClick={scrollToContact}
          className="inline-flex items-center gap-2 bg-neutral-900 text-white px-8 py-4 rounded-sm text-lg font-normal hover:bg-neutral-800 transition-colors duration-200 shadow-lg hover:shadow-xl"
        >
          Request a Quote
          <ArrowRight className="w-5 h-5" />
        </button>
      </div>
    </section>
  );
}
